import { render } from "./QrcodeNavBannerShell.vue?vue&type=template&id=013b72a9&scoped=true"
import script from "./QrcodeNavBannerShell.vue?vue&type=script&lang=js"
export * from "./QrcodeNavBannerShell.vue?vue&type=script&lang=js"

import "./QrcodeNavBannerShell.vue?vue&type=style&index=0&id=013b72a9&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013b72a9"]])

export default __exports__